// 设计稿宽度 375px，基准 1rem = 10px
const DESIGN_WIDTH = 375;
const BASE_FONT_SIZE = 10;
const MAX_FONT_SIZE = 20;

// 计算 rem 基准值
export const mainResize = () => {
  const clientWidth =
    document.documentElement.clientWidth || document.body.clientWidth || 0;
  let fontSize = (clientWidth / DESIGN_WIDTH) * BASE_FONT_SIZE;
  fontSize = Math.min(fontSize, MAX_FONT_SIZE);
  document.documentElement.style.fontSize = fontSize + 'px';
};

// 防抖，避免高频触发
let resizeTimer: ReturnType<typeof setTimeout> | null = null;
const debouncedResize = () => {
  if (resizeTimer) clearTimeout(resizeTimer);
  resizeTimer = setTimeout(mainResize, 150);
};

// 初始化自适应监听
export const initResponsive = () => {
  mainResize();
  window.addEventListener('resize', debouncedResize);
  window.addEventListener('orientationchange', debouncedResize);
};

// 移除监听（页面卸载时调用）
export const destroyResponsive = () => {
  window.removeEventListener('resize', debouncedResize);
  window.removeEventListener('orientationchange', debouncedResize);
  if (resizeTimer) {
    clearTimeout(resizeTimer);
    resizeTimer = null;
  }
};

initResponsive();
